import {
  COMPOSICION_PLAN,
  ETIQUETA_COBERTURA_OPCIONAL,
  ItemComposicionPlan,
  SUBCOBERTURA_EMBEBIDA_RAYONES,
} from '../Models/composicionPlan';

const normalizar = (valor: unknown): string => String(valor ?? '').trim().toLowerCase();
const nombreDe = (cobertura: any): string => normalizar(cobertura?.name ?? cobertura?.Name);

/**
 * Etiquetas de las coberturas incluidas para el resumen de compra.
 *
 * Usa el mismo catalogo y el mismo orden que la tarjeta de planes, pero con el
 * texto corto: sin los limites ni el fragmento resaltado que alli se muestran.
 *
 * Una cobertura que el backend incluya y no este en el catalogo se devuelve con
 * su nombre crudo, al final, para no perderla en silencio.
 */
export function etiquetasCoberturasResumen(
  coveragesGroup: any[] | undefined,
  altoCilindraje: boolean,
): string[] {
  const incluidas = (coveragesGroup ?? []).filter(
    (cobertura) =>
      cobertura?.include === true &&
      nombreDe(cobertura) !== normalizar(SUBCOBERTURA_EMBEBIDA_RAYONES),
  );
  const nombresIncluidos = incluidas.map(nombreDe);

  const delCatalogo = COMPOSICION_PLAN.filter((item) =>
    nombresIncluidos.includes(normalizar(item.nombreApi)),
  ).map((item) => textoResumenDe(item, altoCilindraje));

  const sinCatalogar = incluidas
    .filter(
      (cobertura) =>
        !COMPOSICION_PLAN.some((item) => normalizar(item.nombreApi) === nombreDe(cobertura)),
    )
    .map((cobertura) => String(cobertura?.name ?? cobertura?.Name ?? ''));

  return [...delCatalogo, ...sinCatalogar];
}

function textoResumenDe(item: ItemComposicionPlan, altoCilindraje: boolean): string {
  if (altoCilindraje && item.textoResumenAltoCilindraje) {
    return item.textoResumenAltoCilindraje;
  }

  return item.textoResumen ?? `${item.nombreApi}.`;
}

/** Etiquetas visibles de las coberturas opcionales que el usuario activo. */
export function etiquetasCoberturasOpcionales(codigos: string[] | undefined): string[] {
  return (codigos ?? []).map((codigo) => ETIQUETA_COBERTURA_OPCIONAL[codigo] ?? codigo);
}
